module.exports = __webpack_public_path__ + "img/mp3.d936dcec.svg";